import { render, staticRenderFns } from "./CDescription.vue?vue&type=template&id=0aa8ef63&"
import script from "./CDescription.vue?vue&type=script&lang=js&"
export * from "./CDescription.vue?vue&type=script&lang=js&"
import style0 from "./CDescription.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports